// extracted by mini-css-extract-plugin
export default {"checkboxGroup":"styles_checkboxGroup__03TUB","label":"styles_label__uA8Y4"};